import Link from '@/components/link-component'
import routes from '@/constants/routes'
import { useTranslations } from '@/utils/locale'

export default function HelpUsefulLinks(props: { className?: string }) {
  const { t } = useTranslations()
  const usefulLinks = [
    { link: '/download/', text: t('Download Bitwarden'), unicode: '\ue928' },
    {
      link: 'https://community.bitwarden.com/t/about-the-feature-requests-category',
      text: t('Feature Request'),
      unicode: '\ue965',
    },
    {
      link: 'https://community.bitwarden.com/c/support/',
      text: t('Ask the Community'),
      unicode: '\ue963',
    },
    {
      link: '/learning/',
      text: t('Learning Center'),
      unicode: '\ue963',
    },

    {
      link: routes.contributorGuidelines,
      text: t('Contributor Guidelines'),
      unicode: '\ue934',
    },
  ]
  return (
    <ul className={`list-none ${props?.className}`}>
      {usefulLinks.map((link, i) => (
        <li className="py-1" key={`h-useful-${i}`}>
          <Link to={link.link} className="flex items-center gap-2 text-primaryBlue hover:text-indigoBlue dark:hover:text-white">
            <span className="font-bwi text-sm">{link.unicode}</span>{' '}
            <span className="md:text-sm lg:text-base">{link.text}</span>
          </Link>
        </li>
      ))}
    </ul>
  )
}
